//duplicate of PresenceState from stage3
export enum Availabilities {
	Online = "Online",
	Available = "Available",
	AvailableIdle = "AvailableIdle",
	Busy = "Busy",
	BusyIdle = "BusyIdle",
	DND = "DoNotDisturb",
	Unavailable = "Unavailable",
	BeRightBack = "BeRightBack",
	Away = "Away",
	Offline = "Offline",
	PresenceUnknown = "PresenceUnknown",
	Offering = "Offering",
}

export enum Activity {
	Available = "Available",
	AvailableLocked = "AvailableLocked",
	BusyInACall = "InACall",
	// Server-side CCPresenceActivity.BusyOffering — the value carried by UserPresenceChanged when a new
	// interaction is being offered. Not to be confused with Availabilities.Offering.
	Offering = "Offering"
}

export interface PresenceModel {
	id: string;
	availability: string;
	activity: string;
	reasons: ReasonModel[];
}

export interface ReasonModel {
	id: string;
	name: string;
	presence: number;
	isDeleted: boolean;
	queueRef: string;
}
